import React, { useEffect, useState } from 'react';
import { Modal, Toast } from 'antd-mobile';
import VipHeaderImg from '@/assets/images/vip/vip_header.png';
import QrCodeImg from '@/assets/images/vip/qrcode.png';
import SimpleQrcode from '@/assets/images/vip/small_qrcode.png';
import FeatureDiffImg from '@/assets/images/vip/feature_diff.png';
import TopBg from '@/assets/images/vip/top_bg.png';
import envelopeImg from '@/assets/images/vip/envelope.png';
import BtnTips from '@/assets/images/vip/btn_tips.png';

import VipBookTitleImg from '@/assets/images/vip/vip-book-title.png';
import VipBookCoverImg from '@/assets/images/vip/vip-book-cover.png';

import VipVoiceTitleImg from '@/assets/images/vip/vip-voice-title.png';
import VipVoiceCoverImg from '@/assets/images/vip/vip-voice-cover.png';

import VipWriteTitleImg from '@/assets/images/vip/vip-write-title.png';
import VipWriteCoverImg from '@/assets/images/vip/vip-write-cover.png';

import { isApp, isWechat } from '../../utils/EnvUtils';
import DownLoad from './DownLoad';
import { JsBridge, messageMethodIsSupport } from '../../utils/JsBridge';

function VipSale() {
  const [vipType, setVipType] = useState('forever'); // month, forever

  function handleCheckVip(type: string) {
    setVipType(type);
  }

  return (
    <div className='flex items-center flex-col bg-[#FFF29E]'>
      <img alt='' src={VipHeaderImg} className='w-full' />

      <div className='w-full px-[24px] mt-[-42px]'>
        <div className='flex justify-around'>
          <div
            onClick={() => handleCheckVip('forever')}
            className={`w-[140px] h-[180px] font-bold rounded-[8px] flex flex-col items-center justify-center ${
              vipType === 'forever'
                ? 'border-[#F6C56A] border-[4px]'
                : 'border-[grey]/50 border-[2px]'
            } $`}
          >
            <div className='text-[30px]'>99元</div>
            <div className='text-[20px] text-[#F6C56A]'>永久会员</div>
          </div>
          <div
            onClick={() => handleCheckVip('month')}
            className={`w-[140px] h-[180px] font-bold rounded-[8px] flex flex-col items-center justify-center ${
              vipType === 'month'
                ? 'border-[#F6C56A] border-[4px]'
                : 'border-[grey]/50 border-[2px]'
            } $`}
          >
            <div className='text-[30px]'>9.9元</div>
            <div className='text-[20px] text-[#F6C56A]'>月卡</div>
          </div>
        </div>
        <div className='text-[16px] font-bold w-full h-[40px] rounded-full flex items-center justify-center border-[#F6C56A] border-[2px] mt-[20px]'>
          立即购买
        </div>
      </div>

      <div>
        <img alt='' src={FeatureDiffImg} className='w-[360px] mr-[4px]' />
      </div>

      <div className='flex items-center flex-col bg-[#FFF29E] mt-[46px]'>
        <div className='flex items-center flex-col'>
          <img alt='' src={VipBookTitleImg} className='w-[311px]' />
          <div className='text-[16px] text-[#4E2F12] mt-[16px]'>
            专业海量资源免费读，持续更新
          </div>
          <img alt='' src={VipBookCoverImg} className='w-full' />
        </div>

        <div className='flex items-center flex-col mt-[28px]'>
          <img alt='' src={VipVoiceTitleImg} className='w-[305.5px]' />
          <div className='text-[16px] text-[#4E2F12] mt-[16px]'>
            正确率、语速、语调等立体打分
          </div>
          <img alt='' src={VipVoiceCoverImg} className='w-full' />
        </div>

        <div className='flex items-center flex-col mt-[28px]'>
          <img alt='' src={VipWriteTitleImg} className='w-[251.5px]' />
          <div className='text-[16px] text-[#4E2F12] mt-[16px]'>
            自然拼读、填词、句子全覆盖
          </div>
          <img alt='' src={VipWriteCoverImg} className='w-full' />
        </div>
      </div>

      {!isApp() && <DownLoad />}

      <div className='h-[50px]'></div>
    </div>
  );
}

export default VipSale;
